import React from 'react';

const IconComposition = (props) => (
  <svg width={100} height={100} viewBox="-30 -30 550 550" {...props}>
    <path d="M37.063 303.594h218.531c8.375 0 16.656-2.219 24-6.438l189.375-109.344c7.063 21.906 10.625 44.563 10.625 67.781 0 123.5-100.5 224-224 224-106.281.001-196.406-74.968-218.531-175.999m-36.657-32c8.313 133.906 119.219 240 255.188 240 141.375 0 256-114.625 256-256 0-40.938-9.844-79.469-26.938-113.781L263.594 269.438a16.013 16.013 0 0 1-8 2.156H.406zm0-32h239.188V.406C111.031 8.375 8.375 111.031.406 239.594zm36.688-32c18.594-84.969 85.531-151.906 170.5-170.5v170.5h-170.5zM303.594 37c45.438 9.813 86.219 33.281 117.469 67.656l-117.469 67.813V37m-32-36.594v227.469l197.219-113.844C425.719 49.25 353.906 5.5 271.594.406z" />
  </svg>
);

export default IconComposition;
